module.exports = __webpack_public_path__ + "static/media/grid-item-a6.fe4c625b.png";